<template>
  <div class="cs4-cart" v-if="!!cartJSON && !!dictionary">
    <div class="cs-header__menuIconWrapper cs-header__cartWrapper" v-on:click="onCartIconClick()" v-if="!cartOpen">
      <img class="cs-header__menuIcon cs-header__menuIconCart" src="https://comprasocial.me/wp-content/themes/cs-theme/assets/images/cart.svg" alt="">
      <div class="cs-header__cartCounter" id="cs-header__cartCounter">{{ getCartItemNumber()}} </div>
    </div>
    <div class="cs4-cart__overlay" v-if="cartOpen && !!cartJSON" v-on:click="toggleCart()"></div>
    <div class="cs4-cart__content" v-if="cartOpen && !!cartJSON">
      <div class="cs4-cart__loading" v-if="isLoading">
        <div class="cs4-cart__loadingIcon">
          <div></div>
          <div></div>
        </div>
      </div>
      <div class="cs4-cart-header">
        <div class="cs4-cart__logo">
          <img src="https://comprasocial.me/wp-content/themes/cs-theme/assets/images/logo.png" alt="comprasocial logo" class="cs4-cart__logoImage">
        </div>
        <div class="cs4-cart__close" v-on:click="toggleCart()">
          <img class="cs4-cart__closeIcon" src="https://comprasocial.me/wp-content/themes/cs-theme/assets/images/icon-close.svg" alt="close icon">
        </div>
    </div>
    <div class="cs4-cart__container">
      <div class="cs4-cart__title">{{dictionary.yourCart}}</div>
    <div class="cs4-cart__subtitle" v-if="getCartItemNumber() > 0">{{getCartItemNumber() > 1 ? dictionary.thereAre : dictionary.thereIs }} <span class="cs4-cart__itemCount">{{ getCartItemNumber()}} </span> {{getCartItemNumber() > 1 ? dictionary.services : dictionary.service }}:</div>
    <CouponBar v-if="getCartItemNumber() > 0" :nonce="cartNonce" :cart="cartJSON" :dictionary="dictionary" @cartRefresh="refreshCart" @toggleLoading="toggleLoading()"></CouponBar>
    <CartItems v-if="getCartItemNumber() > 0" :cartItems="cartJSON.items" :dictionary="dictionary" 
      @deleteCartItem="deleteCartItem" @toggleBonusActive="toggleBonusActive" :showBonusCTA="!showCartCTA()" :isBonusActive="isBonusActive"
      :bonusOfferItemKey="!!findCartItemFor(dictionary.bonusQuantityOfferID) ? findCartItemFor(dictionary.bonusQuantityOfferID).key : null"
      ></CartItems>
    <CartCTA :dictionary="dictionary" v-if="showCartCTA() && getCartItemNumber() > 0"></CartCTA>
    </div>
    <CartSummary v-if="getCartItemNumber() > 0" :cartTotals="cartJSON.totals" :dictionary="dictionary" @toggleLoading="toggleLoading()"></CartSummary>
    <CartEmpty v-if="getCartItemNumber() <= 0" :dictionary="dictionary" @closeCart="toggleCart()"></CartEmpty>
    <CartCTA :dictionary="dictionary" v-if="getCartItemNumber() == 0"></CartCTA>
    </div>
    
</div>
</template>

<script>
import CouponBar from './components/CouponBar/CouponBar.vue'
import CartItems from './components/CartItems/CartItems.vue';
import CartSummary from './components/CartSummary/CartSummary.vue';
import CartEmpty from './components/CartEmpty.vue';
import CartCTA from './components/CartCTA/CartCTA.vue';
const axios = require('axios').default;
export default {
  name: 'App',
  data(){
    return {
      cartJSON: null,
      cartOpen: false,
      cartNonce: null,
      isLoading: false,
      dictionary: {},
      isCheckoutPage: false,
      isBonusActive: false
    }
  },
  methods: {
    toggleLoading() {
      this.isLoading = !this.isLoading;
    },
    toggleCart() {
      this.toggleBodyScroll();
      this.cartOpen = !this.cartOpen;
    },
    showCartCTA(){
      return this.getCartItemNumber() < 2 || Number.parseInt(this.cartJSON.totals.total_price) < 1500;
    },
    getCartItemNumber(){
      return this.isBonusActive? this.cartJSON.items_count - 1 : this.cartJSON.items_count;
    },
    activateBonus(){
      this.removeBonusKeys();
      sessionStorage.setItem(`cs4-bonus-key-${this.getCartHash()}`, 'true');
      this.isBonusActive = true;
    },
    deactivateBonus(){
      this.removeBonusKeys();
      sessionStorage.setItem(`cs4-bonus-key-${this.getCartHash()}`, 'false');
      this.isBonusActive = false;
    },
    removeBonus(){
      this.removeBonusKeys();
      this.isBonusActive = false;
    },
    removeBonusKeys(){
      var n = sessionStorage.length;
      while(n--){
        var key = sessionStorage.key(n);
        if(key.indexOf('cs4-bonus-key') > -1){
          sessionStorage.removeItem(key);
        }
      }
    },
    isBonusActivated(){
      return sessionStorage.getItem(`cs4-bonus-key-${this.getCartHash()}`) == 'true';
    },
    async toggleBonusActive(){
      if(this.isBonusActive){
        try{
          await this.deleteCartItem(this.findCartItemFor(this.dictionary.bonusQuantityOfferID).key, false);
        } catch(e){
          console.log(e);
        } finally {
          this.deactivateBonus();
        }
      } else if(!this.showCartCTA()){
          await this.addCartItem(this.dictionary.bonusQuantityOfferID);
          await this.refreshCart();
          this.activateBonus();
      }
    },
    async addCartItem(productID){
      const urlSearchParams = new URLSearchParams();
      urlSearchParams.append('action','woocommerce_ajax_add_to_cart');
      urlSearchParams.append('product_id', productID);
      urlSearchParams.append('quantity', 1);
      // eslint-disable-next-line no-undef
      return axios.post(wc_add_to_cart_params.ajax_url, urlSearchParams,{
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
    },
    findCartItemFor(productID){
      return this.cartJSON.items.find(item => item.id == productID);
    },
    getCartHash(){
      var name = "woocommerce_cart_hash=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    toggleBodyScroll() {
      document.body.classList.toggle('no-scroll');
    },
    async onCartIconClick() {
      await this.refreshCart();
      if(!this.showCartCTA() && ( sessionStorage.getItem(`cs4-bonus-key-${this.getCartHash()}`) == "null" || sessionStorage.getItem(`cs4-bonus-key-${this.getCartHash()}`) == null) ){
        this.toggleBonusActive();
      }
      this.toggleCart();
    },
    async refreshCart(){
      this.toggleLoading();
      this.refreshBonusSession();
      return axios.get('/wp-json/wc/store/cart')
      .then((response) => {
      this.toggleLoading();
        this.cartNonce = response.headers.get('Nonce');
        this.cartJSON = response.data;
        if (this.showCartCTA() && this.isBonusActive){
          this.toggleBonusActive();
        } 
      })
      .catch(() => {
      this.toggleLoading();
      });
    },
    refreshBonusSession(){
      for(let i = 0; i < sessionStorage.length; i++){
        const currentKey = sessionStorage.key(i);
        const currentValue = sessionStorage.getItem(currentKey);
        if(currentKey.includes("cs4-bonus-key-")){
          sessionStorage.removeItem(currentKey);
          sessionStorage.setItem(`cs4-bonus-key-${this.getCartHash()}`, currentValue);
        }
      }
    },
    async deleteCartItem(key, isDirectDelete = true){
      this.toggleLoading();
      return axios.post('/wp-json/wc/store/cart/remove-item', {
          key: key
      },{headers: {
          'Nonce': this.cartNonce
        }},)
      .then( (response) => {
        this.toggleLoading();
        
        this.cartNonce = response.headers.get('Nonce');
        this.cartJSON = response.data;
        if(this.showCartCTA() && isDirectDelete){
          this.toggleBonusActive();
          this.removeBonus();
        }
        if(this.isCheckoutPage){
          location.reload();
        }
      })
      .catch(() => {
      this.toggleLoading();
      });
    }
  },
  components: {
    CouponBar,
    CartItems,
    CartSummary, 
    CartEmpty,
    CartCTA
  },
  mounted() {
    axios.get('/wp-json/wc/store/cart')
      .then((response) => {
        this.cartNonce = response.headers.get('Nonce');
        this.cartJSON = response.data;
      });
      // eslint-disable-next-line no-undef
      axios.get('https://comprasocial.me/wp-content/themes/cs-theme/assets/cs-cart/dictionary-' + currentLanguage + '.json').then(res => {
        this.dictionary = res.data;
    }); 

    if (window.location.href.indexOf('checkout') > -1 ||
        window.location.href.indexOf('commande') > -1 ||
        window.location.href.indexOf('verificar') > -1 ) {
      this.isCheckoutPage = true;
    }
    this.isBonusActive = this.isBonusActivated();
  }
}
</script>

<style lang="scss" scoped>


.cs4-cart {
  position: relative;
  font-family: 'Poppins', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #fff;
  margin-top: 60px;
  margin: 0 auto;

  &__overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 200;
    display: block;
  }

  &__loading{
    position: absolute;
    background: rgba(255, 255, 255, 0.3);
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 203;
    display: flex;
    justify-content: center;
    align-items: center;
    &Icon{
      display: inline-block;
      position: relative;
      width: 80px;
      height: 80px;

      div {
        position: absolute;
        border: 4px solid #cef;
        opacity: 1;
        border-radius: 50%;
        animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
      }

      div:nth-child(2) {
        animation-delay: -0.5s;
      }
    }
  }

  &__icon {
    width: 40px;
    height: 40px;
    background-color:#f00;
    float: right;
  }

  &__content{
    background: linear-gradient(180deg, #0C9DC2 1.87%, #5EF373 97.37%);   position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 201;
    @media screen and (min-width: 1024px) {
      left: unset;
    }
  }
  
  
  &-header {
    display: grid;
    grid-template-columns: auto 80px;
    padding: 15px 0 ;
    overflow: hidden;

    @media screen and (min-width: 1024px) {
      padding: 25px 0 15px;
    }
  }

  &__logo {
    grid-column: 1 / span 2;
    grid-row: 1;
    justify-content: center;
    display: flex;

    &Image { 
      width: 250px;
      height: 40px;
    }
  }

  &__close {
    grid-row: 1;
    grid-column: 2;
    margin: 0 10px 0 25px;
    cursor: pointer;
    display: flex;
    justify-content: center;

    @media  screen and (min-width: 1024px) {
      margin: 0 40px 0 20px;
    }
    
    &Icon{
      width: 20px;
      height: 20px;
      margin-top: 2px;
    }
  }

  &__container {
    overflow-y: scroll;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */

    //set maximum height minus 145px
    max-height: calc(100% - 190px);

    &::-webkit-scrollbar {
      display: none;
    } 

    @media  screen and (min-width: 1024px) {
      width: 420px;
    }
      
  } 

  &__title {
    font-size: 26px;
    font-weight: 700;
    line-height: 30px;
  }

  &__subtitle {
    font-size: 20px;
    font-weight: 400;
  }

  &__itemCount {
    font-weight: 700;
  }

  
}

@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  4.9% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  5% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}

</style>
